import { render, staticRenderFns } from "./TvstSpotlightModule.vue?vue&type=template&id=7b7bc5ba&scoped=true"
import script from "./TvstSpotlightModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./TvstSpotlightModule.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TvstSpotlightModule.vue?vue&type=style&index=0&id=7b7bc5ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7bc5ba",
  null
  
)

export default component.exports